import { ReactElement } from 'react'

import { isDocumentTypeRecurringInvoice } from '@features/invoices/utils/isDocumentTypeRecurringInvoice'

import { useInvoiceEditorActions } from '../../contexts/invoiceEditorActionsContext'
import { useInvoiceEditorDocumentType } from '../../hooks/useInvoiceEditorDocumentType'
import { InvoiceEditorActions } from './elements/InvoiceEditorActions'
import { RecurringInvoiceEditorActions } from './elements/RecurringInvoiceEditorActions'
import * as Styled from './styles'

export const InvoiceEditorSideActions = (): ReactElement => {
  const { isProcessing } = useInvoiceEditorActions()
  const { documentType } = useInvoiceEditorDocumentType()

  const isRecurringInvoice = isDocumentTypeRecurringInvoice(documentType)

  return (
    // Wrapper prevents layout shift when loading starts by reserving space with shouldIncreaseWidth.
    <Styled.InvoiceEditorSideActionsWrapper shouldIncreaseWidth={isProcessing}>
      {isRecurringInvoice ? <RecurringInvoiceEditorActions /> : <InvoiceEditorActions />}
    </Styled.InvoiceEditorSideActionsWrapper>
  )
}
